/**
 * @generated SignedSource<<71cb4d0d005eeb05df0c8a5f5613e22b>>
 * @relayHash d64b36da2f901fa90653ae60fa1c0e96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4ef517be4e85b0d712fa26b3fee68eccc61afbdf5ec8c1c70f73e751b0ba0d1b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type usernameResolverQuery$variables = {
  cql: string;
};
export type usernameResolverQuery$data = {
  readonly searchUser: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly user: {
          readonly accountId: string | null | undefined;
          readonly displayName: string | null | undefined;
          readonly profilePicture: {
            readonly path: string;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type usernameResolverQuery = {
  response: usernameResolverQuery$data;
  variables: usernameResolverQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cql"
  }
],
v1 = [
  {
    "alias": "searchUser",
    "args": [
      {
        "kind": "Variable",
        "name": "cql",
        "variableName": "cql"
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 25
      },
      {
        "kind": "Literal",
        "name": "sitePermissionTypeFilter",
        "value": "all"
      }
    ],
    "concreteType": "ConfluenceSearchConnection",
    "kind": "LinkedField",
    "name": "confluence_searchUser",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceSearchResponseEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "ConfluenceSearchResponse",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": "user",
                "concreteType": "ConfluencePerson",
                "kind": "LinkedField",
                "name": "confluencePerson",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "displayName"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "accountId"
                  },
                  {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "profilePicture",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "path"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "usernameResolverQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usernameResolverQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d64b36da2f901fa90653ae60fa1c0e96",
    "id": "4ef517be4e85b0d712fa26b3fee68eccc61afbdf5ec8c1c70f73e751b0ba0d1b",
    "metadata": {},
    "name": "usernameResolverQuery",
    "operationKind": "query",
    "text": "query usernameResolverQuery($cql:String!){searchUser:confluence_searchUser(cql:$cql,first:25,sitePermissionTypeFilter:\"all\"){edges{node{user:confluencePerson{displayName,accountId,profilePicture{path}}}}}}"
  }
};
})();

(node as any).hash = "b3bcfd40385902ef428c9c3b9dc32d7a";

export default node;
